var render = function render(){
  var _vm$nextEvent, _vm$nextEvent2, _vm$nextEvent3, _vm$nextEvent4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "position": "relative",
      "z-index": "1000"
    }
  }, [_vm.showBanner && _vm.nextEvent ? _c('v-row', {
    staticClass: "event-banner pa-0",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-sm-none",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "text-h5 event-title mb-0"
  }, [_vm._v(_vm._s(_vm.nextEvent.eventTitle))])]), _c('v-expansion-panel-content', [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-content-center align-items-center mb-2",
    attrs: {
      "cols": "6",
      "sm": "3",
      "md": "2",
      "order": "1",
      "order-sm": "1"
    }
  }, [_c('div', {
    staticClass: "event-timer d-flex ml-5"
  }, [_vm.timeRemaining > 86400000 ? [_c('div', {
    staticClass: "time-box"
  }, [_c('span', {
    staticClass: "time-value"
  }, [_vm._v(_vm._s(_vm.displayDays))]), _c('span', {
    staticClass: "time-label"
  }, [_vm._v("DAYS")])]), _c('div', {
    staticClass: "colon-box"
  }, [_c('span', {
    staticClass: "colon"
  }, [_vm._v(":")])]), _c('div', {
    staticClass: "time-box"
  }, [_c('span', {
    staticClass: "time-value"
  }, [_vm._v(_vm._s(_vm.displayHours))]), _c('span', {
    staticClass: "time-label"
  }, [_vm._v("HRS")])])] : _vm.timeRemaining > 600000 ? [_c('div', {
    staticClass: "time-box"
  }, [_c('span', {
    staticClass: "time-value"
  }, [_vm._v(_vm._s(_vm.displayHours))]), _c('span', {
    staticClass: "time-label"
  }, [_vm._v("HRS")])]), _c('div', {
    staticClass: "colon-box"
  }, [_c('span', {
    staticClass: "colon"
  }, [_vm._v(":")])]), _c('div', {
    staticClass: "time-box"
  }, [_c('span', {
    staticClass: "time-value"
  }, [_vm._v(_vm._s(_vm.displayMinutes))]), _c('span', {
    staticClass: "time-label"
  }, [_vm._v("MINS")])])] : [_c('div', {
    staticClass: "time-box"
  }, [_c('span', {
    staticClass: "time-value"
  }, [_vm._v(_vm._s(_vm.displayMinutes))]), _c('span', {
    staticClass: "time-label"
  }, [_vm._v("MIN")])]), _c('div', {
    staticClass: "colon-box"
  }, [_c('span', {
    staticClass: "colon"
  }, [_vm._v(":")])]), _c('div', {
    staticClass: "time-box"
  }, [_c('span', {
    staticClass: "time-value"
  }, [_vm._v(_vm._s(_vm.displaySeconds))]), _c('span', {
    staticClass: "time-label"
  }, [_vm._v("SEC")])])]], 2)]), _c('v-col', {
    staticClass: "text-left d-flex justify-content-left align-items-center",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "8",
      "order-sm": "2"
    }
  }, [_c('div', {
    staticClass: "event-info"
  }, [_c('p', {
    staticClass: "event-description",
    domProps: {
      "innerHTML": _vm._s((_vm$nextEvent = _vm.nextEvent) === null || _vm$nextEvent === void 0 ? void 0 : _vm$nextEvent.description)
    }
  })])]), _c('v-col', {
    staticClass: "d-flex justify-content-left align-items-center mb-2",
    attrs: {
      "cols": "6",
      "sm": "3",
      "md": "2",
      "order": "2",
      "order-sm": "3",
      "mb": "2"
    }
  }, [_c('v-btn', {
    staticClass: "btn-register",
    on: {
      "click": _vm.register
    }
  }, [_c('router-link', {
    staticStyle: {
      "color": "#FFF"
    },
    attrs: {
      "to": {
        name: 'event-detail',
        query: {
          id: (_vm$nextEvent2 = _vm.nextEvent) === null || _vm$nextEvent2 === void 0 ? void 0 : _vm$nextEvent2.id
        }
      }
    }
  }, [_vm._v("Read More ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "pb-0 d-none d-sm-flex justify-content-center align-items-center mt-2 mb-2",
    attrs: {
      "cols": "6",
      "sm": "3",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "event-timer d-flex ml-5"
  }, [_vm.timeRemaining > 86400000 ? [_c('div', {
    staticClass: "time-box"
  }, [_c('span', {
    staticClass: "time-value"
  }, [_vm._v(_vm._s(_vm.displayDays))]), _c('span', {
    staticClass: "time-label"
  }, [_vm._v("DAYS")])]), _c('div', {
    staticClass: "colon-box"
  }, [_c('span', {
    staticClass: "colon"
  }, [_vm._v(":")])]), _c('div', {
    staticClass: "time-box"
  }, [_c('span', {
    staticClass: "time-value"
  }, [_vm._v(_vm._s(_vm.displayHours))]), _c('span', {
    staticClass: "time-label"
  }, [_vm._v("HRS")])])] : _vm.timeRemaining > 600000 ? [_c('div', {
    staticClass: "time-box"
  }, [_c('span', {
    staticClass: "time-value"
  }, [_vm._v(_vm._s(_vm.displayHours))]), _c('span', {
    staticClass: "time-label"
  }, [_vm._v("HRS")])]), _c('div', {
    staticClass: "colon-box"
  }, [_c('span', {
    staticClass: "colon"
  }, [_vm._v(":")])]), _c('div', {
    staticClass: "time-box"
  }, [_c('span', {
    staticClass: "time-value"
  }, [_vm._v(_vm._s(_vm.displayMinutes))]), _c('span', {
    staticClass: "time-label"
  }, [_vm._v("MINS")])])] : [_c('div', {
    staticClass: "time-box"
  }, [_c('span', {
    staticClass: "time-value"
  }, [_vm._v(_vm._s(_vm.displayMinutes))]), _c('span', {
    staticClass: "time-label"
  }, [_vm._v("MIN")])]), _c('div', {
    staticClass: "colon-box"
  }, [_c('span', {
    staticClass: "colon"
  }, [_vm._v(":")])]), _c('div', {
    staticClass: "time-box"
  }, [_c('span', {
    staticClass: "time-value"
  }, [_vm._v(_vm._s(_vm.displaySeconds))]), _c('span', {
    staticClass: "time-label"
  }, [_vm._v("SEC")])])]], 2)]), _c('v-col', {
    staticClass: "d-none p-0 d-sm-flex text-left justify-start align-center",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "7"
    }
  }, [_c('div', {
    staticClass: "event-info mt-4"
  }, [_c('p', {
    staticClass: "event-title",
    domProps: {
      "innerHTML": _vm._s((_vm$nextEvent3 = _vm.nextEvent) === null || _vm$nextEvent3 === void 0 ? void 0 : _vm$nextEvent3.eventTitle)
    }
  }), _c('p', {
    staticClass: "event-description mt-2 mb-3 mb-0",
    domProps: {
      "innerHTML": _vm._s(_vm.nextEvent.description)
    }
  })])]), _c('v-col', {
    staticClass: "d-none d-sm-flex justify-center align-center mt-2",
    attrs: {
      "cols": "6",
      "sm": "3",
      "md": "2"
    }
  }, [_c('v-btn', {
    staticClass: "btn-register",
    on: {
      "click": _vm.register
    }
  }, [_c('router-link', {
    staticStyle: {
      "color": "#FFF"
    },
    attrs: {
      "to": {
        name: 'event-detail',
        query: {
          id: (_vm$nextEvent4 = _vm.nextEvent) === null || _vm$nextEvent4 === void 0 ? void 0 : _vm$nextEvent4.id
        }
      }
    }
  }, [_vm._v("Read More ")])], 1)], 1)], 1) : _c('v-row', [_c('pageHeader', {
    attrs: {
      "showBackgroundImage": false
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }